import { useEffect, useState } from "react";
import { getCookie } from "@utils/Cookies";
import { COOKIE_SHOW_ANDROID_APP } from "@utils/constants";
import { COOKIE_EXPIRE_DAYS } from "./constants";

export const useAppBanner = () => {
  const [showAppDownload, setShowAppDownload] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);
  const [isClosed, setIsClosed] = useState(true);

  useEffect(() => {
    const userAgent = navigator.userAgent || window.opera;

    setIsAndroid(/android/i.test(userAgent));
    setIsClosed(getCookie().get(COOKIE_SHOW_ANDROID_APP) === "true");
  }, []);

  const openDownload = () => setShowAppDownload(true);

  const closeBanner = () => {
    getCookie().set(COOKIE_SHOW_ANDROID_APP, true, {}, COOKIE_EXPIRE_DAYS);
    setIsClosed(true);
    setShowAppDownload(false);
  };

  return {
    showAppDownload,
    isAndroid,
    isClosed,
    openDownload,
    closeBanner,
  };
};
